/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable func-names */
/* eslint-disable no-undef */
import { removeLiveChat } from '@/features/common/plugins/liveChat';

export function removeUserback() {
  if (window.Userback) {
    const userbackButton = document.querySelector('#userback_button_container');
    if (userbackButton) userbackButton.remove();
    window.Userback = null;
  }
}

export function setFeedback() {
  removeLiveChat();
  window.Userback = window.Userback || {};
  Userback.access_token = process.env.VUE_APP_USERBACK_TOKEN;
  (function (d) {
    const s = d.createElement('script'); s.async = true;
    s.src = 'https://static.userback.io/widget/v1.js';
    (d.head || d.body).appendChild(s);
  }(document));
}
